import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { useLanguageContext } from '../../hooks/useContext/useLanguageContext';
import { useTheme } from '@mui/material/styles';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguageContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="large"
        edge="start"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{ marginLeft: '5px', marginRight: '20px' }}
      >
        <LanguageIcon sx={{ fontSize: 40, cursor: 'pointer', color: theme.palette.common.error }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="language-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => handleLanguageChange('en')}>
          {language === 'en' && (
            <ListItemIcon>
              <CheckIcon fontSize="small" />
            </ListItemIcon>
          )}
          <ListItemText inset={language !== 'en'}>🇬🇧 English</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleLanguageChange('pl')}>
          {language === 'pl' && (
            <ListItemIcon>
              <CheckIcon fontSize="small" />
            </ListItemIcon>
          )}
          <ListItemText inset={language !== 'pl'}>🇵🇱 Polski</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
